import React from "react";
import { motion } from "framer-motion";
import { Apple, Play, Globe } from "lucide-react";
import Aurea from "../../assets/store/icon-aurea.png";
import Lia from "../../assets/store/icon-lia.png";
import { useTranslation } from "react-i18next";

const Examples = () => {
	const { t } = useTranslation();
	const primaryColor = "#43BD98";
	const accentColor = "#43BD98";

	const examples = [
		{
			name: "Aurea Store",
			image: Aurea,
			androidLink:
				"https://play.google.com/store/apps/details?id=com.applaby.aurea",
			iosLink: "https://apps.apple.com/us/app/aurea-moda/id6742684349",
			webLink: null,
		},
		{
			name: "Lía Joyas",
			image: Lia,
			androidLink:
				"https://play.google.com/store/apps/details?id=com.applaby.lia",
			iosLink: "https://apps.apple.com/us/app/lia/id6745760514",
			webLink: "https://web.applaby.com/lia-joyas",
		},
	];

	return (
		<section
			id="ejemplos"
			style={{
				padding: "6rem 2rem",
				backgroundColor: "#ffffff",
				fontFamily: "'Poppins', sans-serif",
				textAlign: "center",
				scrollMarginTop: "100px",
			}}
		>
			{/* Encabezado */}
			<motion.div
				initial={{ opacity: 0, y: 30 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				viewport={{ once: true }}
				style={{ marginBottom: "3rem" }}
			>
				<p
					style={{
						color: accentColor,
						fontSize: "0.9rem",
						fontWeight: 600,
						letterSpacing: "1px",
						textTransform: "uppercase",
						marginBottom: "0.5rem",
					}}
				>
					{t("store.examples.badge")}
				</p>
				<h2
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						color: "#1a1a1a",
						fontWeight: 800,
						margin: 0,
					}}
				>
					{t("store.examples.title")}
				</h2>
			</motion.div>

			{/* Tarjetas */}
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					gap: "2rem",
					justifyContent: "center",
				}}
			>
				{examples.map((example, index) => (
					<motion.div
						key={index}
						initial={{ opacity: 0, y: 40 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: index * 0.2 }}
						viewport={{ once: true, amount: 0.3 }}
						whileHover={{
							y: -6,
							scale: 1.03,
							boxShadow:
								"0 15px 45px rgba(67,189,152,0.25), 0 0 0 1px rgba(67,189,152,0.08)",
							transition: { duration: 0.3 },
						}}
						style={{
							width: "300px",
							backgroundColor: "#fff",
							borderRadius: "16px",
							boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
							overflow: "hidden",
							border: "1px solid rgba(67,189,152,0.15)",
						}}
					>
						<img
							src={example.image}
							alt={example.name}
							style={{
								width: "100%",
								display: "block",
								height: "200px",
								objectFit: "cover",
							}}
						/>
						<div style={{ padding: "1.5rem" }}>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "0.6rem",
								}}
							>
								{/* Botón Web si existe */}
								{example.webLink && (
									<a
										href={example.webLink}
										target="_blank"
										rel="noopener noreferrer"
										className="inline-flex items-center justify-center gap-1.5 bg-primary text-white font-semibold px-5 py-2.5 rounded-lg text-sm hover:bg-primary/90 transition-colors"
									>
										<Globe size={14} />
										{t("store.examples.webStore")}
									</a>
								)}
								{/* Fila con Play y App Store */}
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										gap: "0.5rem",
									}}
								>
									<a
										href={example.androidLink}
										target="_blank"
										rel="noopener noreferrer"
										className="flex items-center gap-1.5 border border-gray-300 text-gray-600 font-medium px-3 py-2 rounded-lg text-xs hover:border-primary hover:text-primary transition-colors"
									>
										<Play size={14} />
										Play Store
									</a>
									<a
										href={example.iosLink}
										target="_blank"
										rel="noopener noreferrer"
										className="flex items-center gap-1.5 border border-gray-300 text-gray-600 font-medium px-3 py-2 rounded-lg text-xs hover:border-primary hover:text-primary transition-colors"
									>
										<Apple size={14} />
										App Store
									</a>
								</div>
							</div>
						</div>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default Examples;
